var map = {
	"./Birthday-Cake.jpg": 9712,
	"./Chocolate-Fully-Iced.jpg": 8911,
	"./Cookie-Cake-Base.jpg": 6005,
	"./Double-Fudge.jpg": 2243,
	"./Icing.jpg": 64,
	"./M&M copy.jpg": 3119,
	"./M&M.jpg": 2514,
	"./Oatmeal-Walnut-Raisin.jpg": 7842,
	"./Original-Chocolate-Chip.jpg": 563,
	"./Sugar.jpg": 2882,
	"./Vanilla-Fully-Iced.jpg": 2690,
	"./m-birthday-cake-mm.jpg": 1003,
	"./m-double-fudge-mm.jpg": 7362,
	"./m-oatmeal-walnut-raisin-mm.jpg": 7129,
	"./m-original-chocolate-chip-mm.jpg": 3738,
	"./m-sugar-mm.jpg": 1733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;